import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Modal, Row, Column } from '@pella/sash-framework';
import { Image, CTA } from '../../';
import { getCookie, removeCookie } from '../../utilities/functions';
import { useAccount } from '../../../hooks/use-account';

export default function ModalSignedOut() {
	const data = useStaticQuery(query).contentstackGlobalConfig;
	const { logout } = useAccount();
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const checkExpireCookie = async () => {
			if (getCookie('expire_modal') != null) {
				const expires = JSON.parse(getCookie('expire_modal'));
				const today = new Date();
				if (today > new Date(expires)) {
					setIsOpen(true);
					await logout();
				}
			}
		};

		checkExpireCookie();
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, []);

	if (!data) return null;

	const onCloseModalClick = () => {
		setIsOpen(false);
		if (getCookie('expire_modal') != null) removeCookie('expire_modal');
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onCloseModalClick}
			width={1000}
			className='[&>button]:right-0 [&>button]:top-0 [&>button]:h-8 [&>button]:w-8 [&>button]:border-4 [&>button]:border-white md:[&>button]:right-1 md:[&>button]:top-1 md:[&>button]:h-10 md:[&>button]:w-10'
		>
			<Row noGutters>
				{data.signed_out.image?.[0] && (
					<Column
						xs={12}
						sm={5}
					>
						<Image
							data={data.signed_out.image[0]}
							className='block h-[150px] w-full border-[15px] border-white sm:h-[300px] lg:h-[450px] lg:border-[25px]'
						/>
					</Column>
				)}

				<Column
					xs={12}
					sm='fluid'
				>
					<div className='flex h-full flex-col justify-center px-4 pb-4 text-center tracking-wide sm:pl-0 sm:pt-6 lg:pb-6 lg:pr-6 lg:pt-12'>
						<div className='max-w-full px-6'>
							{data.signed_out.subheading && <p className='mx-auto mb-2.5 text-xl lg:text-26px'>{data.signed_out.subheading}</p>}
							{data.signed_out.heading && <h3 className='mb-5 text-22px uppercase tracking-3px lg:mb-12 lg:text-28px'>{data.signed_out.heading}</h3>}
							{data.signed_out.description && <p className='mx-auto max-w-[45ch]'>{data.signed_out.description}</p>}
						</div>

						{data.signed_out.cta?.[0] && (
							<CTA
								data={data.signed_out.cta[0]}
								className='mt-5 max-w-full sm:mt-auto'
								wide
							/>
						)}
					</div>
				</Column>
			</Row>
		</Modal>
	);
}

export const query = graphql`
	{
		contentstackGlobalConfig {
			signed_out {
				image {
					...Image
					image {
						url
						gatsbyImageData(quality: 90, width: 370)
					}
				}
				subheading
				heading
				description
				ctas {
					...CTA
				}
			}
		}
	}
`;
